import logo from './logo.svg'

export const theme = {
    color: {
      primary: "#E30045",
      primaryHover: "#7B0B18",
    },
    logoImage: logo,
    backend: "https://publik-epaper.verdi.de/",
    directory: "/kiosk",
    header: {
      customer: "",
      title: "ver.di publik E-Paper",
      lineHeader: true,
    },
    accToolbar: true,
    info: [
      {
        text: 'Impressum',
        link: 'https://publik.verdi.de/impressum/'
      },
      {
        text: 'Datenschutz',
        link: 'https://www.verdi.de/datenschutz'
      }
  ]
  };
